import axios from 'axios';

import { serverErrorCode } from '@tallo/design-system';
import { roleRequiredErrorCode } from '@tallo/investor/company';
import { useInvestorStore } from '@tallo/investor/investor';

let reload: Promise<void> | null = null;

/**
 * An admin route refusing the seat means its role changed since sign-in: the seat is read again so
 * the admin controls go away. The refusal still reaches the caller, which shows it.
 */
export function installStaleRoleInterceptor(): void {
  axios.interceptors.response.use(undefined, (error) => {
    if (error?.response?.status === 403 && serverErrorCode(error) === roleRequiredErrorCode && !reload) {
      reload = useInvestorStore()
        .load()
        .catch(() => undefined)
        .finally(() => {
          reload = null;
        });
    }

    return Promise.reject(error);
  });
}
